import { useId, useLabels } from '../utils';
/**
 * Provides the accessibility implementation for labels and their associated elements.
 * Labels provide context for user inputs.
 * @param props - The props for labels and fields.
 */ export function useLabel(props) {
    const { label, 'aria-label': ariaLabel, labelElementType = 'label' } = props;
    const id = useId(props.id);
    const labelId = useId();
    let ariaLabelledby = props['aria-labelledby'];
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === 'label' ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) {
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn('If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility');
        }
    }
    const fieldProps = useLabels({
        id,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    return {
        labelProps,
        fieldProps
    };
}

//# sourceMappingURL=useLabel.js.map